import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { AuthorizationService } from 'src/app/features-common/services/authorization.service';

@Directive({
  selector: '[CanHideIfUnauthorized]'
})
export class CanHideIfUnauthorizedDirective implements OnInit {
  @Input('myHideIfUnauthorized') permission: string; // Required permission passed in

  constructor(private el: ElementRef, private authorizationService: AuthorizationService) { }

  ngOnInit() {
    if (!this.authorizationService.hasPermission(this.permission)) {
      this.el.nativeElement.style.display = 'none';
    }
  }
}
